// KL guide in Bahasa Melayu: harga servis aircond. hreflang pair with the
// English /aircond-service-price page.
const content = {
    lang: 'ms',
    slug: 'harga-servis-aircond',
    title: (c) => `Harga Servis Aircond di KL (${new Date().getFullYear()}) | Dari ${c.money(c.tables.general[0].wall)}`,
    description: (c) =>
        `Senarai harga servis aircond di Kuala Lumpur: servis biasa ${c.money(c.tables.general[0].wall)}, chemical wash ${c.money(c.tables.chemicalWash[0].wall)}, overhaul dan tambah gas. Harga tetap.`,
    eyebrow: 'KL · Harga',
    h1: 'Harga Servis Aircond di Kuala Lumpur',
    lead: 'Harga penuh untuk setiap jenis servis - termasuk pengangkutan, tanpa caj tersembunyi pada hari servis. Harga seunit lebih murah apabila anda servis semua aircond di rumah serentak.',
    datePublished: '2026-10-03',
    image: 'blog/living/aircon/repairman-doing-air-conditioner-service.jpg',
    imageAlt: 'Juruteknik sedang menservis aircond di rumah',
    summary: {
        title: 'Harga ringkas (1 unit dinding)',
        items: [],
    },
    sections: [
        {
            title: 'Servis biasa (general service)',
            paragraphs: ['Cuci penapis, coil, blower dan paip air. Disyorkan setiap tiga hingga empat bulan.'],
            table: {
                columns: [
                    { key: 'unit', label: 'Bilangan unit' },
                    { key: 'harga', label: 'Harga' },
                    { key: 'seunit', label: 'Seunit' },
                ],
                rows: (c) => c.tables.general.map((r) => ({ unit: `${r.units} unit`, harga: c.money(r.wall), seunit: c.money(r.perUnitWall) })),
            },
        },
        {
            title: 'Chemical wash dan chemical overhaul',
            paragraphs: ['Chemical wash membuang kulat dan bau tanpa menurunkan unit. Overhaul pula membuka keseluruhan unit untuk dicuci bahagian demi bahagian.'],
            table: {
                columns: [
                    { key: 'unit', label: 'Bilangan unit' },
                    { key: 'wash', label: 'Chemical wash' },
                    { key: 'overhaul', label: 'Chemical overhaul' },
                ],
                rows: (c) => c.tables.chemicalWash.map((r, i) => ({ unit: `${r.units} unit`, wash: c.money(r.wall), overhaul: c.money(c.tables.chemicalOverhaul[i].wall) })),
            },
        },
        {
            title: 'Tambah gas (seunit luar)',
            table: {
                columns: [
                    { key: 'gas', label: 'Jenis gas' },
                    { key: 'topup', label: 'Tambah gas' },
                    { key: 'penuh', label: 'Isi penuh' },
                ],
                rows: (c) => ['R32', 'R410A', 'R22'].map((g) => ({ gas: g, topup: c.money(c.tables.gas[g].half), penuh: c.money(c.tables.gas[g].full) })),
            },
            note: 'Gas hanya berkurang jika ada kebocoran. Juruteknik akan memeriksa tekanan dahulu sebelum menambah gas.',
        },
        {
            title: 'Aircond siling (cassette) dan pakej tahunan',
            paragraphs: [
                (c) => `Servis biasa untuk aircond cassette bermula ${c.money(c.tables.general[0].ducted)} seunit. Pakej servis tahunan (tiga kali setahun) untuk satu unit berharga ${c.money(c.tables.annual[0].threeTimes)} setahun.`,
                (c) => `Lawatan diagnosis kerosakan: ${c.money(c.tables.repairDiagnosis)}. Juruteknik akan memberi sebut harga pembaikan sebelum memulakan kerja.`,
            ],
        },
    ],
    faqs: [
        {
            question: 'Berapa harga servis aircond di KL?',
            answer: (c) => `Servis biasa ${c.money(c.tables.general[0].wall)} untuk satu unit, ${c.money(c.tables.general[2].wall)} untuk tiga unit. Chemical wash ${c.money(c.tables.chemicalWash[0].wall)} seunit.`,
        },
        {
            question: 'Adakah ada caj pengangkutan?',
            answer: 'Tiada. Pengangkutan di KL dan kawasan Lembah Klang berdekatan sudah termasuk dalam harga.',
        },
        {
            question: 'Apa beza servis biasa dan chemical wash?',
            answer: 'Servis biasa menggunakan air. Chemical wash menggunakan bahan kimia untuk menanggalkan kotoran dan kulat yang melekat pada coil - sesuai jika aircond berbau atau kurang sejuk.',
        },
    ],
    alternates: [
        { hreflang: 'en-my', path: '/my/aircond-service-kuala-lumpur/aircond-service-price' },
        { hreflang: 'ms-my', path: '/my/aircond-service-kuala-lumpur/harga-servis-aircond' },
    ],
    relatedLinks: [
        { href: '/my/aircond-service-kuala-lumpur/aircond-service-price', title: 'Read in English: Aircond Service Price in KL' },
    ],
    cta: {
        title: 'Tempah servis aircond anda',
        body: 'Pilih servis, bilangan unit dan masa - harga ditunjukkan sebelum anda menempah.',
        href: '/my/aircond-service-kuala-lumpur',
        label: 'Lihat semua servis',
        bookSummary: 'servis aircond di KL',
        bookLabel: 'Tempah sekarang',
    },
}

// Summary bullets quote live prices.
content.summary.items = (c) => [
    `Servis biasa: ${c.money(c.tables.general[0].wall)}`,
    `Chemical wash: ${c.money(c.tables.chemicalWash[0].wall)}`,
    `Chemical overhaul: ${c.money(c.tables.chemicalOverhaul[0].wall)}`,
    `Tambah gas R32: ${c.money(c.tables.gas.R32.half)}`,
]

export default content
